export default __webpack_public_path__ + "static/media/IMG_5570.acd5f95f.jpg";